import reducer from './reducers'

export { default as mainSelectors } from './selectors'
export { default as mainOperations } from './operations'

export default reducer
